import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// The JWT is kept exclusively in a secure, HTTPOnly cookie set by the backend
// (see auth_utils.py). We never read or write it from JavaScript/localStorage,
// which removes the XSS token-theft risk that comes with client-accessible
// storage. `withCredentials` ensures the cookie is sent on every request.
const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      if (!["/login", "/register", "/demo"].includes(window.location.pathname)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { API_BASE, BACKEND_URL };
